module.exports = __webpack_public_path__ + "static/media/Account.7a40fe67.svg";